import { Outlet } from "react-router";

import classes from "./Layout.module.css";
import SideBar from "../../components/SideBar/SideBar";
import { useAuth } from "../../context/AuthContext";
import { useEffect, useState } from "react";

const Layout = () => {
  const { user, logout } = useAuth();

  const [showLogoutPopup, setShowLogoutPopup] = useState(false);


  useEffect(() => {
    const handleClickOutside = (e) => {
      if (!e.target.closest(`.${classes.avatarContianer}`) && !e.target.closest(`.${classes.logoutPopup}`)) {
        setShowLogoutPopup(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleTogglePopup = () => {
    setShowLogoutPopup(!showLogoutPopup);
  };

  const handleLogout = () => {
    // Your logout logic here
    logout();
    console.log("Logging out...");
  };



  return (
    <div className={`${classes.main}`}>
      <div
        className={`${classes.header} d-flex align-items-center justify-content-between w-100`}
      >
        <div>
          <img src="/KATA-LOGO.svg" />
        </div>

        <div className={`d-flex align-items-center gap-2 position-relative`}>
          <div
            className={classes.avatarContianer}
            onClick={handleTogglePopup}
            style={{ cursor: "pointer" }}
          ></div>
          <p onClick={handleTogglePopup} style={{ cursor: "pointer" }}>
            {user?.fullName || ""}
          </p>

          {showLogoutPopup && (
            <div className={classes.logoutPopup}>
              <button onClick={handleLogout}>Logout</button>
            </div>
          )}
        </div>
      </div>
      <div className={` d-flex`}>
        <SideBar />
        <div className={classes.content}>
          {/* <Routes>
          <Route path="/" element={<Navigate to="/dashboard" />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/laboratory-mapping/profile" element={<Profile />} />
          <Route path="/laboratory-mapping/profile/edit-profile" element={<EditProfile />} />
          <Route path="/laboratory-mapping/infrastructure" element={<Infrastructure />} />
          <Route path="/laboratory-mapping/reports" element={<Reports />} />
          <Route path="/laboratory-mapping/specimen-referral" element={<SpecimenReferral />} />
          <Route path="/laboratory-mapping/biosafety" element={<Biosafety />} />
          <Route path="/laboratory-mapping/logistics" element={<LogisticsSupplyChain />} />
          <Route path="/laboratory-mapping/qms" element={<QualityManagementSystem />} />
          <Route path="/certification/slipta/audit-summary" element={<AuditSummary />} />
          <Route path="/accreditation/sadcas-f134-a" element={<AccreditationA />} />
          <Route path="*" element={<NotFound />} />
        </Routes> */}
          <Outlet /> {/* This renders the matched child route */}
        </div>
      </div>
    </div>
  );
};

export default Layout;
